<template lang="html">
  <!-- Componente localizado en le header.vue como <cart-express-modal> -->
  <div>
    <sweet-modal :icon="$root.modalCartObj.icon" :blocking="true" :hide-close-button="true" ref="modal">
      <div v-html="$root.modalCartObj.msg"></div>

      <div class="col-12 text-center" style="padding-top: 20px;" v-if="$root.modalCartObj.icon == 'success'">
        <button class="btn btn-secondary" v-on:click.prevent="closeModal">Agregar mas productos</button>
        <button class="btn btn-success" v-on:click.prevent="closeModal('goCart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></button>
      </div>

      <div class="col-12 text-center" style="padding-top: 20px;" v-else>
        <b-button class="btn btn-danger px-5" slot="button" v-on:click.prevent="closeModal">Cerrar ventana</b-button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
export default {
  methods: {
    closeModal(val){
      this.$refs.modal.close();

      this.$root.modalCartObj = {
        msg:'',
        icon:'',
      };

      if(val == 'goCart'){
        this.$router.push('/cart');
      }

      setTimeout(()=> {
        this.$root.openModalCart = false;
      }, 400);
    }
  },

  mounted(){
    this.$refs.modal.open();
  }
}
</script>
